import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { ChatMemberInfo } from '../chat.models';
import { UserStatusPipe } from '../utils/user-status.pipe';

@Component({
  selector: 'be-user-avatar',
  templateUrl: './user-avatar.component.html',
  styleUrls: ['./user-avatar.component.scss'],
  imports: [NgOptimizedImage, UserStatusPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserAvatarComponent {
  avatar = input<string | undefined>(undefined);
  initials = input<string | undefined>(undefined);
  colorInfo = input<{ foreground: string; background: string } | undefined>(undefined);
  isGroupChat = input<boolean | undefined>(undefined);
  status = input.required<ChatMemberInfo[]>();

  chatAvatar = computed(() => {
    return this.avatar() || (this.isGroupChat() ? 'assets/images/icon-multiple-users-24.svg' : '');
  });
}
